import { render, staticRenderFns } from "./lista_clinica_cupos.vue?vue&type=template&id=802a0d2c"
import script from "./lista_clinica_cupos.vue?vue&type=script&lang=js"
export * from "./lista_clinica_cupos.vue?vue&type=script&lang=js"
import style0 from "./lista_clinica_cupos.vue?vue&type=style&index=0&id=802a0d2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports